import { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { productcards } from "../utils/productsList";

import Modal from "./Modal";
import Overlay from "./Overlay";
import SpecialMeal from "./SpecialMeal/SpecialMeal";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3.35,
  },
  tablet: {
    breakpoint: { max: 1023, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Products = () => {
  const [show, setShow] = useState(false);
  const [category, setCategory] = useState("burger");

  const handleShow = (name) => {
    setShow(true);
    setCategory(name);
  };

  return (
    <div className="w-full h-full mt-[3rem]  xl:mt-[2.75rem]">
      {/* MODAL */}
      <Modal show={show} close={() => setShow(false)}>
        {show && <Overlay category={category} />}
      </Modal>
      <Carousel
        arrows={true}
        responsive={responsive}
        className="w-full h-full flex z-0"
      >
        {productcards.map((el, id) => {
          return (
            <SpecialMeal
              key={id}
              data={el}
              handleShow={() => handleShow(el.name)}
            />
          );
        })}
      </Carousel>
    </div>
  );
};

export default Products;
